
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireStraight as ObiWireStraightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-straight.js';
 
 
 

 
 export const ObiWireStraight = createComponent({
   react: React,
   tagName: 'obi-wire-straight',
   elementClass: ObiWireStraightElement,
   events: {
     
   }
  });
 
 